"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "w-full 2xl:container print-text-sm mx-auto p-4 flex flex-col" };
const _hoisted_2 = { class: "filters justify-between lg:items-end print:hidden" };
const _hoisted_3 = { class: "flex flex-col md:flex-row gap-4" };
const _hoisted_4 = { class: "flex flex-col md:flex-row gap-4" };
const _hoisted_5 = { class: "flex items-center justify-center gap-2 font-bold" };
const _hoisted_6 = { class: "text-center font-bold" };
const _hoisted_7 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_8 = { class: "text-center" };
const _hoisted_9 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_10 = { class: "text-center" };
const _hoisted_11 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_12 = { class: "text-center" };
const _hoisted_13 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_14 = { class: "text-center" };
const _hoisted_15 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_16 = { class: "text-center" };
const _hoisted_17 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_18 = { class: "text-center" };
const _hoisted_19 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_20 = { class: "text-center" };
const _hoisted_21 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_22 = { class: "text-center" };
const _hoisted_23 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_24 = { class: "text-center" };
const _hoisted_25 = { class: "flex flex-row gap-1 justify-center items-center text-[24px] print:hidden" };
const _hoisted_26 = ["onClick"];
const _hoisted_27 = ["title"];
const _hoisted_28 = ["onClick"];
const _hoisted_29 = ["title"];
const _hoisted_30 = ["onClick"];
const _hoisted_31 = ["title"];
const _hoisted_32 = ["onClick"];
const _hoisted_33 = ["title"];
const vue_3 = require("vue");
const i18n_1 = require("../../common/i18n");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const ShopInput_vue_1 = __importDefault(require("../../components/Form/ShopInput.vue"));
const Modal_vue_1 = __importDefault(require("../../components/Modal.vue"));
const OpenOrderItems_vue_1 = __importDefault(require("./OpenOrderItems.vue"));
const UploadOrderInvoice_vue_1 = __importDefault(require("./UploadOrderInvoice.vue"));
const UploadedOrderInvoices_vue_1 = __importDefault(require("./UploadedOrderInvoices.vue"));
const OrderNote_vue_1 = __importDefault(require("./OrderNote.vue"));
const toastStore_1 = require("../../stores/toast/toastStore");
const securityStore_1 = require("../../stores/security/securityStore");
const PermissionEnum_1 = require("../../models/permission/PermissionEnum");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
const vue_router_1 = require("vue-router");
exports.default = (0, vue_1.defineComponent)({
    __name: 'OpenOrders',
    setup(__props) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const router = (0, vue_router_1.useRouter)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const openOrders = (0, vue_3.ref)([]);
        const selectedOpenOrder = (0, vue_3.ref)(null);
        const currentUser = (0, vue_3.computed)(() => {
            return securityStore.authenticatedUser;
        });
        const openOrderItemsModalIsOpen = (0, vue_3.ref)(false);
        const uploadOrderInvoiceModalIsOpen = (0, vue_3.ref)(false);
        const uploadedOrderInvoicesModalIsOpen = (0, vue_3.ref)(false);
        const orderNoteModalIsOpen = (0, vue_3.ref)(false);
        const openOrderIdPartial = (0, vue_3.ref)("");
        const openOrderListFields = (0, vue_3.ref)([
            {
                key: "id",
                label: (_a = (0, i18n_1.trans)("id_open_order_list", "ID", "open_orders")) !== null && _a !== void 0 ? _a : "ID",
                value: "id",
            },
            {
                key: "date",
                label: (_b = (0, i18n_1.trans)("date_open_order_list", "Date", "open_orders")) !== null && _b !== void 0 ? _b : "Date",
                value: "date",
            },
            {
                key: "status",
                label: (_c = (0, i18n_1.trans)("status_open_order_list", "Status", "open_orders")) !== null && _c !== void 0 ? _c : "Status",
                value: "status",
            },
            {
                key: "address",
                label: (_d = (0, i18n_1.trans)("address_open_order_list", "Address", "open_orders")) !== null && _d !== void 0 ? _d : "Address",
                value: "address",
            },
            {
                key: "quantity",
                label: (_e = (0, i18n_1.trans)("quantity_open_order_list", "Quantity", "open_orders")) !== null && _e !== void 0 ? _e : "Quantity",
                value: "quantity",
            },
            {
                key: "netAmount",
                label: (_f = (0, i18n_1.trans)("net_amount_open_order_list", "Net Amount", "open_orders")) !== null && _f !== void 0 ? _f : "Net Amount",
                value: "netAmount",
            },
            {
                key: "openedQuantity",
                label: (_g = (0, i18n_1.trans)("opened_quantity_open_order_list", "Opened Quantity", "open_orders")) !== null && _g !== void 0 ? _g : "Opened Quantity",
                value: "openedQuantity",
            },
            {
                key: "openedNetAmount",
                label: (_h = (0, i18n_1.trans)("opened_net_amount_open_order_list", "Opened Net Amount", "open_orders")) !== null && _h !== void 0 ? _h : "Opened Net Amount",
                value: "openedNetAmount",
            },
            {
                key: "shippedQuantity",
                label: (_j = (0, i18n_1.trans)("shipped_quantity_open_order_list", "Shipped Quantity", "open_orders")) !== null && _j !== void 0 ? _j : "Shipped Quantity",
                value: "shippedQuantity",
            },
            {
                key: "shippedNetAmount",
                label: (_k = (0, i18n_1.trans)("shipped_net_amount_open_order_list", "Shipped Net Amount", "open_orders")) !== null && _k !== void 0 ? _k : "Shipped Net Amount",
                value: "shippedNetAmount",
            },
            {
                key: "actions",
                label: "",
            },
        ]);
        const printPage = () => {
            window.print();
        };
        const queryOpenOrders = async () => {
            var _a, _b;
            if (securityStore.authenticatedUser === null) {
                toastStore.addErrorToast((_a = (0, i18n_1.trans)("no_authenticated_user", "There is no authenticated user", "open_orders")) !== null && _a !== void 0 ? _a : "There is no authenticated user");
                return;
            }
            try {
                const url = router.resolve({ name: "axapta_open_orders_api", query: { customerId: securityStore.authenticatedUser.customer.id, orderIdPartial: openOrderIdPartial.value } }).href;
                const response = await (0, fetch_1.default)(url);
                openOrders.value = Array.isArray(response) ? response : ((_b = response.data) !== null && _b !== void 0 ? _b : []);
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const viewOpenOrderItems = (openOrder) => {
            selectedOpenOrder.value = openOrder;
            openOrderItemsModalIsOpen.value = true;
        };
        const viewUploadOrderInvoice = (openOrder) => {
            selectedOpenOrder.value = openOrder;
            uploadOrderInvoiceModalIsOpen.value = true;
        };
        const viewUploadedOrderInvoices = (openOrder) => {
            selectedOpenOrder.value = openOrder;
            uploadedOrderInvoicesModalIsOpen.value = true;
        };
        const viewOrderNote = (openOrder) => {
            selectedOpenOrder.value = openOrder;
            orderNoteModalIsOpen.value = true;
        };
        (0, vue_3.onBeforeMount)(() => {
            openOrders.value = [];
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('order_id_placeholder', 'e.g.: VR2698758', 'open_orders'),
                            label: (0, vue_2.unref)(i18n_1.trans)('order_id_partial_label', 'Order ID Partial', 'open_orders'),
                            modelValue: openOrderIdPartial.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((openOrderIdPartial).value = $event)),
                            type: "text",
                            required: "",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        (0, vue_2.createElementVNode)("button", {
                            class: "btn btn-rounded btn-warning h-[48px]",
                            onClick: _cache[1] || (_cache[1] = ($event) => (printPage()))
                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("print", "Print", "customer_product_return_list")), 1),
                        (0, vue_2.createElementVNode)("button", {
                            class: "btn btn-rounded btn-primary h-[40px]",
                            onClick: queryOpenOrders
                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("submit_query", "Submit Query", "open_orders")), 1)
                    ])
                ]),
                (openOrders.value.length > 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ResponsiveTable_vue_1.default, {
                        key: 0,
                        fields: openOrderListFields.value,
                        "onUpdate:fields": _cache[2] || (_cache[2] = ($event) => ((openOrderListFields).value = $event)),
                        items: openOrders.value,
                        class: "print-margin-0 print-text-sm",
                        striped: "",
                        condensed: "",
                        panel: ""
                    }, {
                        "head-id": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_5, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("id", "ID", "open_orders")), 1)
                        ]),
                        "cell-id": (0, vue_2.withCtx)(({ item: openOrder }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_6, (0, vue_2.toDisplayString)(openOrder.id), 1)
                        ]),
                        "head-date": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_7, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("date", "Date", "open_orders")), 1)
                        ]),
                        "cell-date": (0, vue_2.withCtx)(({ item: openOrder }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_8, (0, vue_2.toDisplayString)(openOrder.date), 1)
                        ]),
                        "head-status": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_9, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("status", "Status", "open_orders")), 1)
                        ]),
                        "cell-status": (0, vue_2.withCtx)(({ item: openOrder }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_10, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)(openOrder.status, openOrder.status, "orders")), 1)
                        ]),
                        "head-address": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_11, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("address", "Address", "open_orders")), 1)
                        ]),
                        "cell-address": (0, vue_2.withCtx)(({ item: openOrder }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_12, (0, vue_2.toDisplayString)(openOrder.shippingName) + " - " + (0, vue_2.toDisplayString)(openOrder.shippingZip) + " " + (0, vue_2.toDisplayString)(openOrder.shippingCity) + ", " + (0, vue_2.toDisplayString)(openOrder.shippingStreet), 1)
                        ]),
                        "head-quantity": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_13, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("quantity", "Quantity", "open_orders")), 1)
                        ]),
                        "cell-quantity": (0, vue_2.withCtx)(({ item: openOrder }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_14, (0, vue_2.toDisplayString)(openOrder.quantity), 1)
                        ]),
                        "head-netAmount": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_15, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("net_amount", "Net Amount", "open_orders")), 1)
                        ]),
                        "cell-netAmount": (0, vue_2.withCtx)(({ item: openOrder }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_16, (0, vue_2.toDisplayString)(openOrder.formattedNetAmount), 1)
                        ]),
                        "head-openedQuantity": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_17, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("opened_quantity", "Opened Quantity", "open_orders")), 1)
                        ]),
                        "cell-openedQuantity": (0, vue_2.withCtx)(({ item: openOrder }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_18, (0, vue_2.toDisplayString)(openOrder.openedQuantity), 1)
                        ]),
                        "head-openedNetAmount": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_19, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("opened_net_amount", "Opened Net Amount", "open_orders")), 1)
                        ]),
                        "cell-openedNetAmount": (0, vue_2.withCtx)(({ item: openOrder }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_20, (0, vue_2.toDisplayString)(openOrder
                                .formattedOpenedNetAmount), 1)
                        ]),
                        "head-shippedQuantity": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_21, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("shipped_quantity", "Shipped Quantity", "open_orders")), 1)
                        ]),
                        "cell-shippedQuantity": (0, vue_2.withCtx)(({ item: openOrder }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_22, (0, vue_2.toDisplayString)(openOrder.shippedQuantity), 1)
                        ]),
                        "head-shippedNetAmount": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_23, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("shipped_net_amount", "Shipped Net Amount", "open_orders")), 1)
                        ]),
                        "cell-shippedNetAmount": (0, vue_2.withCtx)(({ item: openOrder }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_24, (0, vue_2.toDisplayString)(openOrder
                                .formattedShippedNetAmount), 1)
                        ]),
                        "cell-actions": (0, vue_2.withCtx)(({ item: openOrder }) => {
                            var _a;
                            return [
                                (0, vue_2.createElementVNode)("div", _hoisted_25, [
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn btn-rounded btn-primary btn-link",
                                        onClick: ($event) => (viewOpenOrderItems(openOrder))
                                    }, [
                                        (0, vue_2.createElementVNode)("i", {
                                            class: "marso-icon-eye",
                                            title: (0, vue_2.unref)(i18n_1.trans)('view_open_order_items', 'View Open Order Items', 'open_orders')
                                        }, null, 8, _hoisted_27)
                                    ], 8, _hoisted_26),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn btn-rounded btn-primary btn-link",
                                        onClick: ($event) => (viewUploadOrderInvoice(openOrder))
                                    }, [
                                        (0, vue_2.createElementVNode)("i", {
                                            class: "marso-icon-upload",
                                            title: (0, vue_2.unref)(i18n_1.trans)('upload_order_invoice', 'Upload Order Invoice', 'open_orders')
                                        }, null, 8, _hoisted_29)
                                    ], 8, _hoisted_28),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn btn-rounded btn-primary btn-link",
                                        onClick: ($event) => (viewUploadedOrderInvoices(openOrder))
                                    }, [
                                        (0, vue_2.createElementVNode)("i", {
                                            class: "marso-icon-files",
                                            title: (0, vue_2.unref)(i18n_1.trans)('view_uploaded_order_invoices', 'View Uploaded Order Invoices', 'open_orders')
                                        }, null, 8, _hoisted_31)
                                    ], 8, _hoisted_30),
                                    ((_a = (0, vue_2.unref)(currentUser)) === null || _a === void 0 ? void 0 : _a.hasPermission((0, vue_2.unref)(PermissionEnum_1.OrderNotePermissionEnum).ORDER_NOTE_WRITE))
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                            key: 0,
                                            class: "btn btn-rounded btn-primary btn-link",
                                            onClick: ($event) => (viewOrderNote(openOrder))
                                        }, [
                                            (0, vue_2.createElementVNode)("i", {
                                                class: "marso-icon-document-edit",
                                                title: (0, vue_2.unref)(i18n_1.trans)('edit_order_note', 'Edit Order Note', 'open_orders')
                                            }, null, 8, _hoisted_33)
                                        ], 8, _hoisted_32))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ])
                            ];
                        }),
                        _: 1
                    }, 8, ["fields", "items"]))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    isOpen: openOrderItemsModalIsOpen.value,
                    title: selectedOpenOrder.value !== null
                        ? (0, vue_2.unref)(i18n_1.trans)('view_order', 'View Order - Order ID: {id}', 'open_orders', { id: selectedOpenOrder.value.id })
                        : '',
                    onClose: _cache[3] || (_cache[3] = ($event) => (openOrderItemsModalIsOpen.value = false))
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (selectedOpenOrder.value !== null)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(OpenOrderItems_vue_1.default, {
                                key: 0,
                                "open-order": selectedOpenOrder.value
                            }, null, 8, ["open-order"]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    _: 1
                }, 8, ["isOpen", "title"]),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    "is-open": uploadOrderInvoiceModalIsOpen.value,
                    title: selectedOpenOrder.value !== null
                        ? (0, vue_2.unref)(i18n_1.trans)('upload_order_invoice', 'Upload Order Invoice - Order ID: {id}', 'open_orders', { id: selectedOpenOrder.value.id })
                        : '',
                    onClose: _cache[5] || (_cache[5] = ($event) => (uploadOrderInvoiceModalIsOpen.value = false))
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (selectedOpenOrder.value !== null)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(UploadOrderInvoice_vue_1.default, {
                                key: 0,
                                "open-order": selectedOpenOrder.value,
                                onSaved: _cache[4] || (_cache[4] = ($event) => (uploadOrderInvoiceModalIsOpen.value = false))
                            }, null, 8, ["open-order"]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    _: 1
                }, 8, ["is-open", "title"]),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    "is-open": uploadedOrderInvoicesModalIsOpen.value,
                    title: selectedOpenOrder.value !== null
                        ? (0, vue_2.unref)(i18n_1.trans)('uploaded_order_invoices', 'Uploaded Order Invoices - Order ID: {id}', 'open_orders', { id: selectedOpenOrder.value.id })
                        : '',
                    onClose: _cache[6] || (_cache[6] = ($event) => (uploadedOrderInvoicesModalIsOpen.value = false))
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (selectedOpenOrder.value !== null)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(UploadedOrderInvoices_vue_1.default, {
                                key: 0,
                                "open-order": selectedOpenOrder.value
                            }, null, 8, ["open-order"]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    _: 1
                }, 8, ["is-open", "title"]),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    "is-open": orderNoteModalIsOpen.value,
                    title: selectedOpenOrder.value !== null
                        ? (0, vue_2.unref)(i18n_1.trans)('edit_order_note', 'Edit Order Note - Order ID: {id}', 'open_orders', { id: selectedOpenOrder.value.id })
                        : '',
                    onClose: _cache[8] || (_cache[8] = ($event) => (orderNoteModalIsOpen.value = false))
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (selectedOpenOrder.value !== null)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(OrderNote_vue_1.default, {
                                key: 0,
                                "open-order": selectedOpenOrder.value,
                                onSaved: _cache[7] || (_cache[7] = ($event) => (orderNoteModalIsOpen.value = false))
                            }, null, 8, ["open-order"]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    _: 1
                }, 8, ["is-open", "title"])
            ]));
        };
    }
});
